import React from "react"
import { 
  Button, 
  OverlayTrigger,
  Tooltip
} from "react-bootstrap"
import {
  HiX
} from 'react-icons/hi'
import {
  ButtonCreateInterface
} from '../ButtonCreate'

export const ButtonCancel: React.FC <ButtonCreateInterface> = ({
  text,
  icon = false,
  noText = false,
  variant,
  tooltip = true,
  tooltipText,
  tooltipPlacement,
  size = 'sm',
  style,
  ...rest
}) => {
  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={tooltip ? <Tooltip>{tooltipText ?? 'Batal'}</Tooltip> : <div></div>}
    >
      <Button
        {...rest}
        size={size === "sm" ? "sm" : size === "lg" ? "lg" : undefined}
        variant={variant ?? "outline-dark"}
        style={{
          ...style,
          minWidth: icon ? 'auto' : '100px' 
        }}
      >
        <div className="d-flex justify-content-center align-items-center">
          <div>
            {icon && <HiX className="mb-1" />}
          </div>
          {!noText && (
            <span className="mx-1 text-uppercase">
              {text  ? text : 'Batal'}
            </span>
          )}
        </div>
      </Button>
    </OverlayTrigger>
  )
}